/* ==========================================================================
   COLLECTING JOY — LISTIFY WORDING
   Listify's free plan locks its storefront copy to "Registry".
   This swaps it for "Wish List" inside the Listify panel and pages.
   ========================================================================== */

(function () {
  'use strict';

  // Longer phrases first so "Gift Registry" never becomes "Gift Wish List"
  const REPLACEMENTS = [
    [/Gift Registries|Gift Lists/g, 'Wish Lists'],
    [/gift registries|gift lists/g, 'wish lists'],
    [/Gift Registry|Gift List/g, 'Wish List'],
    [/gift registry|gift list/g, 'wish list'],
    [/GIFT REGISTRIES|GIFT LISTS|REGISTRIES/g, 'WISH LISTS'],
    [/GIFT REGISTRY|GIFT LIST|REGISTRY/g, 'WISH LIST'],
    [/Registries/g, 'Wish Lists'],
    [/registries/g, 'wish lists'],
    [/Registry/g, 'Wish List'],
    [/registry/g, 'wish list'],
  ];
  const TEST = /registr|gift list/i;
  const ATTRIBUTES = ['placeholder', 'aria-label', 'title', 'alt'];
  const SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1 };

  function reword(text) {
    return REPLACEMENTS.reduce((out, [pattern, value]) => out.replace(pattern, value), text);
  }

  function rewordNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (TEST.test(node.nodeValue) && !SKIP_TAGS[node.parentNode && node.parentNode.nodeName]) {
        node.nodeValue = reword(node.nodeValue);
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (SKIP_TAGS[node.nodeName]) return;

    if (node.getAttribute) {
      ATTRIBUTES.forEach((name) => {
        const value = node.getAttribute(name);
        if (value && TEST.test(value)) node.setAttribute(name, reword(value));
      });
    }
    node.childNodes.forEach(rewordNode);
    if (node.shadowRoot) watch(node.shadowRoot);
  }

  const watched = new WeakSet();

  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);
    rewordNode(root);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') mutation.addedNodes.forEach(rewordNode);
        else rewordNode(mutation.target);
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTES,
    });
  }

  // Listify mounts into open shadow roots on these containers, sometimes after load
  const isListify = (el) => /listify/i.test(el.id || '') || /listify/i.test(typeof el.className === 'string' ? el.className : '');

  function scan() {
    document.querySelectorAll('[id*="listify" i], [class*="listify" i]').forEach((el) => {
      if (el.shadowRoot) watch(el.shadowRoot);
      watch(el);
    });
    // Shared list pages are served through the app proxy
    if (location.pathname.indexOf('/apps/') === 0) {
      const main = document.querySelector('main') || document.body;
      watch(main);
    }
  }

  scan();
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && (isListify(node) || node.querySelector('[id*="listify" i], [class*="listify" i]'))) {
          scan();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Shadow roots can attach after the container is in the DOM
  let tries = 0;
  const poll = setInterval(() => {
    scan();
    if (++tries >= 20) clearInterval(poll);
  }, 500);
})();
